import * as React from "react";
import {NewCardForm} from "@ferry/journey-services";
import {authorize} from "@athena-portal/components";
import {lazyInject} from "@athena-portal/core";
import {CardForm} from "../../../../../components/payments/CardForm";
import {Types} from "../../../../../Types";
import type {ICustomerPortalService} from "../../../../../services/ICustomerPortalService";

interface IProps {
    verifyNewCardFailed: boolean
    adHocPaymentsAllowed: boolean
    policyNumber?: string
}

interface IState {
    newCardForm?: NewCardForm
}

@authorize
export class ChangeCardForm extends React.Component<IProps, IState> {
    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: IProps) {
        super(props);

        this.state = {
            newCardForm: undefined,
        };
    }

    public componentDidMount() {
        this.customerPortalService.validateNewCard(this.props.adHocPaymentsAllowed, this.props.policyNumber).subscribe((newCardForm: NewCardForm) => {
            this.setState({
                newCardForm
            })
        });
    }

    public render() {
        return (
            <CardForm newCardForm={this.state.newCardForm} verifyNewCardFailed={this.props.verifyNewCardFailed} policyNumber={this.props.policyNumber} />
        );
    }
}
